import { render } from "./Confirmation.vue?vue&type=template&id=2a9fb168&scoped=true"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"

import "./Confirmation.vue?vue&type=style&index=0&id=2a9fb168&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/booking-calendars/titans-booking-calendar/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9fb168"]])

export default __exports__